export const topTabs = [
  {
    option: 'Weather Home',
  },
  {
    option: 'Hourly Forecast',
  },
  {
    option: 'Detailed Forecast',
  },
  {
    option: '15-Day Forecast',
  },
  {
    option: 'Air Quality',
    options: [
      {
        id: 'air-quality-observations',
        title: 'Observations',
      },
      {
        id: 'air-quality-forecast',
        title: 'Forecast',
      },
    ],
  },
];

export const airQualitySubTabs = [
  { option: 'Air Quality Observations' },
  { option: 'Air Quality Forecast' },
];
